<template>
  <Loader v-if="isLoading"/>
  <SliderForm action="edit" :slider="slider" :slides="slides" v-else/>
</template>

<script>
import SliderForm from '@/components/Slider/SliderForm'
import Slider from '@/model/Slider'
import * as types from '@/store/types.js'
import Loader from '@/components/Utils/Loader'

export default {
  components: {
    SliderForm, Loader
  },
  computed: {
    slider () {
      this.$store.dispatch(types.ACTIVE_SLIDER)
      return this.$store.getters[types.ACTIVE_SLIDER]
    }
  },
  data () {
    return {
      slides: [],
      isLoading: true
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      Slider.show(this.$route.params.id).then((response) => {
        this.slides = response.data.data.slides
        this.isLoading = false
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/views/slider/Edit.vue